module.exports = __webpack_public_path__ + "static/media/clock.d2c7e442.svg";